import { apiService } from "@/_services";
import { getExpoData } from "@/_core/data/api_calls/getExpoData";
import { getHedgeDataCommodities } from "@/_core/data/api_calls/getHedgeDataCommodities";
import { getHedgeData } from "@/_core/data/api_calls/getHedgeData";
import { getExpoDataCommodities } from "@/_core/data/api_calls/getExpoDataCommodities";
import { setManagementInfo } from "@/_core/data/DataModel";
import { getCompaniesData } from "@/_core/data/api_calls/getCompaniesData";
import { formatDate_MDYHMS } from "@/_core/_helpers/_helpers";
import { downloadDataModelTable } from "@/_core/data/api_calls/downloadDataModelTable";
import { timeFormat } from "d3";
import axios from "axios";
import { authHeader } from "../../_helpers/auth-header";

// === analytics currency ===
/**
 * Saves budget rate for currencies for provided portfolio
 * @param {object} _this: context variables
 */
export function onClientSaveToDBBudget(_this) {
  let params = {
    method: "POST",
    endpoint: "update_create_budget",
    content_type: "application/json",
    query_params: {
      format: "json",
      companies: 1,
      selected_portfolio: _this.selectedPortfolios,
      budget_rate: _this.budgetRate,
      selected_currency: _this.assets[_this.selectedAsset]
    }
  };
  apiService.getAll(params).catch(function(error) {
    _this.modal_processing_message.showModalLoading = !_this
      .modal_processing_message.showModalLoading;
    _this.modal_process_finished_message.showModalLoading = !_this
      .modal_process_finished_message.showModalLoading;
    _this.modal_process_finished_message.optionsModal = true;
    _this.modal_process_finished_message.messageModal =
      "An error has occurred" + error;
  });
}

// === data model ===
export function onClientSaveToDBExpo(_this) {
  _this.showCompanyPorfolioLoading = true;
  _this.dataSavedExpo = true;
  _this.all_expo = _this.expo.filter(d => d.edited).concat(_this.expo_deleted);
  console.log(_this.all_expo);
  let params = {
    method: "POST",
    endpoint: "update_create_exposurecurrency",
    content_type: "application/json",
    query_params: {
      format: "json",
      currency_exposure: _this.all_expo,
      selected_company: _this.companies[_this.selectedCompany].company_name,
      user_id: _this.user.pk_idusers
    }
  };
  apiService
    .getAll(params)
    .then(async data => {
      await getExpoData(_this);
      await _this.processed_company.onLoadData();

      _this.modal_processing_message.showModalLoading = false;
      _this.modal_process_finished_message.showModalLoading = true;
      _this.modal_process_finished_message.optionsModal = true;
      _this.modal_process_finished_message.messageModal = data["successful"];
      _this.showLoadingExpo = true;

      _this.companies = _this.$store.state.companies.all.items;
      _this.companyLen = _this.companies.length;
      setManagementInfo(_this, 0, false);
      _this.showCompanyPorfolioLoading = false;
    })
    .catch(function(error) {
      _this.modal_processing_message.showModalLoading = !_this
        .modal_processing_message.showModalLoading;
      _this.modal_process_finished_message.showModalLoading = !_this
        .modal_process_finished_message.showModalLoading;
      _this.modal_process_finished_message.optionsModal = true;
      _this.modal_process_finished_message.messageModal =
        "An error has occurred" + error;
    });
  _this.saveLegendExpo = "Saved:";
  _this.refreshLegendExpo = "Synced:";
}

export function onClientSaveToDBExpoCommodities(_this) {
  _this.showCompanyPorfolioLoading = true;
  _this.dataSavedExpoCommodities = true;
  _this.all_expo = _this.expoCommodities
    .filter(d => d.edited)
    .concat(_this.expo_commodities_deleted);
  let params = {
    method: "POST",
    endpoint: "update_create_exposurecommodities",
    content_type: "application/json",
    query_params: {
      format: "json",
      commodity_exposures: _this.all_expo,
      selected_company: _this.companies[_this.selectedCompany].company_name,
      user_id: _this.user.pk_idusers
    }
  };
  _this.modal_processing_message.showModalLoading = !_this
    .modal_processing_message.showModalLoading;
  _this.modal_processing_message.messageModal = "Processing...";
  apiService
    .getAll(params)
    .then(async data => {
      await getExpoDataCommodities(_this);
      await _this.processed_company.onLoadData();

      _this.modal_processing_message.showModalLoading = false;
      _this.modal_process_finished_message.showModalLoading = false;
      _this.modal_process_finished_message.optionsModal = true;
      _this.modal_process_finished_message.messageModal = data["successful"];
      _this.showLoadingExpoCommodities = true;
      _this.companies = _this.$store.state.companies.all.items;
      _this.companyLen = _this.companies.length;
      setManagementInfo(_this, 0, false);
      _this.showCompanyPorfolioLoading = false;
    })
    .catch(function(error) {
      _this.modal_processing_message.showModalLoading = !_this
        .modal_processing_message.showModalLoading;
      _this.modal_process_finished_message.showModalLoading = !_this
        .modal_process_finished_message.showModalLoading;
      _this.modal_process_finished_message.optionsModal = true;
      _this.modal_process_finished_message.messageModal =
        "An error has occurred" + error;
    });
  _this.saveLegendExpo = "Saved:";
  _this.refreshLegendExpo = "Synced:";
}

export function onClientSaveToDBHedgeCommodities(_this) {
  _this.showCompanyPorfolioLoading = true;
  _this.dataSavedHedgeCommodities = true;
  _this.all_expo = _this.expoCommodities
    .filter(d => d.edited)
    .concat(_this.commodities_hedge_deleted);
  let params = {
    method: "POST",
    endpoint: "update_create_hedge_commodity",
    content_type: "application/json",
    query_params: {
      format: "json",
      commodity_hedges: _this.hedgeCommodities,
      selected_company: _this.companies[_this.selectedCompany].company_name,
      user_id: _this.user.pk_idusers
    }
  };
  _this.modal_processing_message.showModalLoading = !_this
    .modal_processing_message.showModalLoading;
  _this.modal_processing_message.messageModal = "Processing....";
  apiService
    .getAll(params)
    .then(async data => {
      await getHedgeDataCommodities(_this);
      // await _this.processed_company.onLoadData();

      _this.modal_processing_message.showModalLoading = false;
      _this.modal_process_finished_message.showModalLoading = false;
      _this.modal_process_finished_message.optionsModal = true;
      _this.modal_process_finished_message.messageModal = data["successful"];
      _this.showLoadingExpoCommodities = true;

      _this.companies = _this.$store.state.companies.all.items;
      _this.companyLen = _this.companies.length;
      setManagementInfo(_this, 0, false);
      _this.showCompanyPorfolioLoading = false;
    })
    .catch(function(error) {
      console.log("An error has occurred" + error);
    });
  _this.saveLegendExpo = "Saved:";
  _this.refreshLegendExpo = "Synced:";
}

export function onClientSaveToDBHedge(_this) {
  _this.dataSavedHedge = true;
  _this.all_hedge = _this.hedge
    .filter(d => d.edited)
    .concat(_this.hedge_deleted);
  let params = {
    method: "POST",
    endpoint: "update_create_hedgecurrency",
    content_type: "application/json",
    query_params: {
      format: "json",
      currency_hedge: _this.all_hedge,
      selected_company: _this.companies[_this.selectedCompany].company_name,
      user_id: _this.user.pk_idusers
    }
  };

  _this.modal_processing_message.showModalLoading = !_this
    .modal_processing_message.showModalLoading;
  _this.modal_processing_message.messageModal = "Processing....";
  apiService
    .getAll(params)
    .then(async data => {
      _this.hedge = [];
      await getHedgeData(_this);
      //await _this.processed_company.onLoadData();
      _this.modal_processing_message.showModalLoading = !_this
        .modal_processing_message.showModalLoading;
      _this.modal_process_finished_message.showModalLoading = !_this
        .modal_process_finished_message.showModalLoading;
      _this.modal_process_finished_message.optionsModal = true;
      _this.modal_process_finished_message.messageModal = data;
      _this.showLoadingHedge = true;

      _this.companies = _this.$store.state.companies.all.items;
      _this.companyLen = _this.companies.length;
      setManagementInfo(_this, 0, false);
      _this.showCompanyPorfolioLoading = false;
    })
    .catch(function(error) {
      _this.modal_processing_message.showModalLoading = !_this
        .modal_processing_message.showModalLoading;
      _this.modal_process_finished_message.showModalLoading = !_this
        .modal_process_finished_message.showModalLoading;
      _this.modal_process_finished_message.optionsModal = true;
      _this.modal_process_finished_message.messageModal =
        "An error has occurred" + error;
    });

  _this.saveLegendHedge = "Saved:";
  _this.refreshLegendHedge = "Synced:";
  _this.processed_company.onLoadData();
}

export function uploadExpo(_this) {
  let formData = new FormData();
  formData.append("file", _this.file);
  formData.append("user_id", _this.user.pk_idusers);
  formData.append(
    "selected_company",
    _this.companies[_this.selectedCompany].company_name
  );
  let params = {
    method: "POST",
    endpoint: "update_create_exposurecurrency_fromfile",
    content_type: "multipart/form-data",
    query_params: {
      formData: formData
    }
  };
  apiService
    .getAll(params)
    .then(async data => {
      _this.modal_processing_message.showModalLoading = false;
      _this.modal_process_finished_message.showModalLoading = true;
      _this.modal_process_finished_message.optionsModal = true;
      await getCompaniesData(_this);
      let answer_text = "";
      if (data["successful"] !== undefined) {
        for (let i in data["successful"]) {
          let text = data["successful"];
          if (data["successful"].length - 1 < 5) {
            if (i < data["successful"].length - 1) {
              answer_text = answer_text + text[i] + ", ";
            } else {
              answer_text = answer_text + text[i] + ".";
            }
          } else {
            answer_text = data;
          }
        }
      } else {
        answer_text = data["successful"];
      }

      _this.modal_process_finished_message.messageModal = answer_text;
      _this.showModalUpload = false;
      _this.showLoadingExpo = true;
      _this.companies = _this.$store.state.companies.all.items;
      _this.companyLen = _this.companies.length;
      setManagementInfo(_this, 0, false);
      getExpoData(_this);
      _this.processed_company.onLoadData();
      _this.showCompanyPorfolioLoading = false;
    })
    .catch(function(error) {
      console.log("An error has occurred" + error);
    });
  _this.processed_company.onLoadData();
}

export function uploadExpoCommodities(_this) {
  let formData = new FormData();
  formData.append("file", _this.file);
  formData.append("user_id", _this.user.pk_idusers);
  formData.append(
    "selected_company",
    _this.companies[_this.selectedCompany].company_name
  );
  let params = {
    method: "POST",
    endpoint: "update_create_exposurecommodity_fromfile",
    content_type: "multipart/form-data",
    query_params: {
      formData: formData
    }
  };
  apiService
    .getAll(params)
    .then(async data => {
      await getCompaniesData(_this);
      _this.modal_processing_message.showModalLoading = false;
      //_this.modal_process_finished_message.showModalLoading = true;
      _this.modal_process_finished_message.optionsModal = true;
      let answer_text = "";
      if (data["successful"] !== undefined) {
        for (let i in data["successful"]) {
          let text = data["successful"];
          if (data["successful"].length - 1 < 5) {
            if (i < data["successful"].length - 1) {
              answer_text = answer_text + text[i] + ", ";
            } else {
              answer_text = answer_text + text[i] + ".";
            }
          } else {
            answer_text = data;
          }
        }
      } else {
        answer_text = data;
      }
      _this.modal_processing_message.showModalLoading = false;
      _this.modal_process_finished_message.showModalLoading = true;
      _this.modal_process_finished_message.optionsModal = true;
      _this.modal_process_finished_message.messageModal = answer_text;
      _this.companyLen = _this.companies.length;
      getExpoDataCommodities(_this);
      setManagementInfo(_this, 0, false);
      _this.showLoadingExpo = true;
      _this.processed_company.onLoadData();
      _this.showCompanyPorfolioLoading = false;
    })
    .catch(function(error) {
      console.log("An error has occurred" + error);
    });
}

export function checkPortfoliosData(rec_data, _this, type) {
  _this.showModalUpload = false;
  if (rec_data["successful"] !== 0) {
    _this.modal_processing_message.showModalLoading = !_this
      .modal_processing_message.showModalLoading;
    _this.modal_process_finished_message.showModalLoading = !_this
      .modal_process_finished_message.showModalLoading;
    _this.modal_process_finished_message.optionsModal = false;
    _this.modal_process_finished_message.messageModal = rec_data;
    if (type === 0) {
      uploadExpo(_this);
    } else {
      uploadExpoCommodities(_this);
    }
  } else {
    if (type === 0) {
      uploadExpo(_this);
    } else {
      uploadExpoCommodities(_this);
    }
  }
}

export function checkPortfolio({
  _this,
  idCompany,
  dataModelName,
  fileName,
  additionalInfo,
  fileData,
  idUser,
  operation = "upload"
}) {
  const endpoint = "upload_datamodel";
  const formData = new FormData();
  const token = authHeader();

  formData.append("company_id", idCompany);
  formData.append("datamodel_name", dataModelName);
  formData.append("operation", operation);
  formData.append("file_name", fileName);
  formData.append("additional_info", additionalInfo);
  formData.append("file_data", fileData);
  formData.append("user_id", idUser);
  _this.loading.showModalLoading = true;
  _this.loading.messageModal = "Processing...";

  axios
    .post(`${process.env.VUE_APP_TRANSFERS_URL}/${endpoint}/`, formData, {
      headers: {
        ...token,
        "Content-Type": "multipart/form-data"
      },
      responseType: "json"
    })
    .then(data => {
      _this.loading.optionsModal = true;
      _this.loading.messageModal = data.data.messages;
    })
    .catch(error => {
      _this.loading.optionsModal = true;
      let errorData = error.response.data.errors;
      let areAllItemsStrings = false;

      if (Array.isArray(errorData)) {
        areAllItemsStrings = errorData.every(item => typeof item === "string");
      }
      if (!areAllItemsStrings) {
        errorData = Array.isArray(errorData) ? errorData[0] : errorData;
        for (let key in errorData) {
          if (Object.prototype.hasOwnProperty.call(errorData, key)) {
            errorData = `${errorData[key][0]}`;
            break;
          }
        }
      }
      const err = areAllItemsStrings ? errorData[0] : errorData;
      _this.loading.messageModal = err;
      console.error("Error uploading data ", error);
    });
}

export function uploadHedge(_this) {
  let formData = new FormData();
  formData.append("file", _this.file);
  formData.append("user_id", _this.user.pk_idusers);
  formData.append(
    "selected_company",
    _this.companies[_this.selectedCompany].company_name
  );
  let params = {
    method: "POST",
    endpoint: "update_create_hedgecurrency_fromfile",
    content_type: "multipart/form-data",
    query_params: {
      formData: formData
    }
  };

  _this.modal_processing_message.messageModal = "Processing...";
  apiService
    .getAll(params)
    .then(async data => {
      var delay_state = _this;
      await getCompaniesData(_this);
      setTimeout(function() {
        delay_state.modal_processing_message.showModalLoading = !delay_state
          .modal_processing_message.showModalLoading;
        delay_state.modal_process_finished_message.showModalLoading = !delay_state
          .modal_process_finished_message.showModalLoading;
        delay_state.modal_process_finished_message.optionsModal = true;
        let answer_text = "";
        if (data["successful"] !== undefined) {
          for (let i in data["successful"]) {
            let text = data["successful"];
            if (data["successful"].length - 1 < 5) {
              if (i < data["successful"].length - 1) {
                answer_text = answer_text + text[i] + ", ";
              } else {
                answer_text = answer_text + text[i] + ".";
              }
            } else {
              answer_text = data;
            }
          }
        } else {
          answer_text = data;
        }

        delay_state.modal_process_finished_message.messageModal = answer_text;
        delay_state.showLoadingHedge = true;

        delay_state.companies = delay_state.$store.state.companies.all.items;
        delay_state.companyLen = delay_state.companies.length;
        setManagementInfo(delay_state, 0, false);
        getHedgeData(_this);
        _this.processed_company.onLoadData();
        delay_state.showCompanyPorfolioLoading = false;
      }, 10000);
    })
    .catch(function(error) {
      _this.modal_processing_message.showModalLoading = !_this
        .modal_processing_message.showModalLoading;
      _this.modal_process_finished_message.showModalLoading = !_this
        .modal_process_finished_message.showModalLoading;
      _this.modal_process_finished_message.optionsModal = true;
      _this.modal_process_finished_message.messageModal =
        "An error has occurred" + error;
    });
}

export function uploadHedgeCommodities(_this) {
  let formData = new FormData();
  formData.append("file", _this.file);
  formData.append("user_id", _this.user.pk_idusers);
  formData.append(
    "selected_company",
    _this.companies[_this.selectedCompany].company_name
  );
  let params = {
    method: "POST",
    endpoint: "update_create_hedgecommodity_fromfile",
    content_type: "multipart/form-data",
    query_params: {
      formData: formData
    }
  };
  _this.modal_processing_message.showModalLoading = true;
  _this.modal_processing_message.messageModal = "Processing...";
  apiService
    .getAll(params)
    .then(async data => {
      await getCompaniesData(_this);
      var delay_state = _this;
      setTimeout(function() {
        delay_state.modal_processing_message.showModalLoading = !delay_state
          .modal_processing_message.showModalLoading;
        delay_state.modal_process_finished_message.showModalLoading = !delay_state
          .modal_process_finished_message.showModalLoading;
        delay_state.modal_process_finished_message.optionsModal = true;
        let answer_text = "";

        if (data["successful"] !== undefined) {
          for (let i in data["successful"]) {
            let text = data["successful"];
            if (data["successful"].length - 1 < 5) {
              if (i < data["successful"].length - 1) {
                answer_text = answer_text + text[i] + ", ";
              } else {
                answer_text = answer_text + text[i] + ".";
              }
            } else {
              answer_text = data["successful"];
            }
          }
        } else {
          answer_text = data;
        }

        delay_state.modal_process_finished_message.messageModal = answer_text;
        delay_state.showLoadingHedge = true;

        delay_state.companies = delay_state.$store.state.companies.all.items;
        delay_state.companyLen = delay_state.companies.length;
        setManagementInfo(delay_state);
        getHedgeDataCommodities(_this, 0, false);
        _this.processed_company.onLoadData();
        delay_state.showCompanyPorfolioLoading = false;
      }, 10000);
    })
    .catch(function(error) {
      _this.modal_processing_message.showModalLoading = !_this
        .modal_processing_message.showModalLoading;
      _this.modal_process_finished_message.showModalLoading = !_this
        .modal_process_finished_message.showModalLoading;
      _this.modal_process_finished_message.optionsModal = true;
      _this.modal_process_finished_message.messageModal =
        "An error has occurred" + error;
    });
}

export function checkPortfoliosDataHedge(rec_data, _this, type) {
  _this.showModalUpload = false;
  if (type === 0) {
    uploadHedge(_this);
  } else {
    uploadHedgeCommodities(_this);
  }
}

export function saveCommodityProgram(_this) {
  _this.jsonObj = { values: {} };
  _this.objective = "cash_flow";
  if (_this.selectedCashFlowGradient === "budget") {
    _this.parameter = "budget";
    _this.jsonObj.values.percentage = _this.cashFlowPercentage;
    _this.jsonObj.values.percentagemonths = _this.cashFlowMonths;
  } else if (_this.selectedCashFlowGradient === "expo") {
    _this.parameter = "constant";
    _this.jsonObj.values.percentage = _this.cashFlowPercentage;
    _this.jsonObj.values.months = _this.cashFlowBudgetMonth;
  } else if (_this.selectedCashFlowGradient === "monthly") {
    if (_this.flow.length === undefined) {
      _this.jsonObj = { values: {} };
      _this.jsonObj = {
        values: {
          "0": 92.31,
          "1": 84.62,
          "2": 76.92,
          "3": 69.23,
          "4": 61.54,
          "5": 53.85,
          "6": 46.15,
          "7": 38.46,
          "8": 30.77,
          "9": 23.08,
          "10": 15.38,
          "11": 7.69
        }
      };
    } else {
      _this.parameter = "monthly";
      _this.jsonObj = { values: {} };
      for (let u = 0; u < this.flow.length; u++) {
        _this.jsonObj.values[u] = _this.flow[u]["percentage"];
      }
    }
  } else {
    _this.parameter = "quarterly";
    if (_this.flow.length === undefined) {
      _this.jsonObj = { values: {} };
      _this.jsonObj = { values: { "0": 80, "1": 60, "2": 40, "3": 20 } };
    } else {
      _this.jsonObj = { values: {} };
      for (let u = 0; u < _this.flow.length; u++) {
        _this.jsonObj.values[u] = _this.flow[u]["percentage"];
      }
    }
  }
  if (_this.parameter === "") _this.parameter = "monthly";
  let params = {
    method: "POST",
    endpoint: "create_commodity_hedging_program",
    content_type: "application/json",
    query_params: {
      format: "json",
      user_id: _this.user.pk_idusers,
      selected_company: _this.selectedCompany.pk_idcompany,
      selected_portfolios: _this.$refs.selected_port.value,
      commodity: _this.$refs.selected_comm.value,
      flow: _this.jsonObj,
      parameter: _this.parameter,
      objective: _this.objective
    }
  };
  _this.jsonObj = { values: {} };
  _this.modal_processing_message.showModalLoading = !_this
    .modal_processing_message.showModalLoading;
  _this.modal_processing_message.messageModal = "Successfully saved program";
  _this.modal_processing_message.optionsModal = true;
  apiService.getAll(params).then(data => {
    console.log(typeof data);
  });
}

// === Analytics for commodities ===
/**
 * Saves budget price for commodities for provided portfolio
 * @param {object} _this: context variables
 */
export function onClientSaveToDBCommodityBudget(_this) {
  let params = {
    method: "POST",
    endpoint: "update_create_commodity_budget",
    content_type: "application/json",
    query_params: {
      format: "json",
      companies: 1,
      selected_portfolio: _this.newSelectedPortfolios,
      budget_rate: _this.budgetRate,
      selected_commodity: _this.assets[_this.selectedAsset]
    }
  };
  apiService.getAll(params).catch(function(error) {
    _this.modal_processing_message.showModalLoading = !_this
      .modal_processing_message.showModalLoading;
    _this.modal_process_finished_message.showModalLoading = !_this
      .modal_process_finished_message.showModalLoading;
    _this.modal_process_finished_message.optionsModal = true;
    _this.modal_process_finished_message.messageModal =
      "An error has occurred" + error;
  });
}

export function saveUserPreferences(_this) {
  let dataModel = JSON.stringify(
    _this.$store.state.user_preferences.all.items.datamodel_choices
  );
  let analytics = JSON.stringify(
    _this.$store.state.user_preferences.all.items.analytics_choices
  );
  let markets = JSON.stringify(
    _this.$store.state.user_preferences.all.items.markets_choices
  );
  let optimizer = JSON.stringify(
    _this.$store.state.user_preferences.all.items.optimizer_choices
  );
  let assetsToDb = JSON.stringify(
    _this.$store.state.user_preferences.all.items.overview_choices
  );

  let hedges = JSON.stringify(
    _this.$store.state.user_preferences.all.items.hedges_choices
  );

  let params = {
    method: "POST",
    endpoint: "save_custom_overview",
    content_type: "application/json",
    query_params: {
      format: "json",
      datamodel_choices: dataModel
        .replace(/'/g, '"')
        .replace(/(True)|(False)/g, "0"),
      analytics_choices: analytics
        .replace(/'/g, '"')
        .replace(/(True)|(False)/g, "0"),
      markets_choices: markets
        .replace(/'/g, '"')
        .replace(/(True)|(False)/g, "0"),
      optimizer_choices: optimizer
        .replace(/'/g, '"')
        .replace(/(True)|(False)/g, "0"),
      assets: assetsToDb,
      hedges_choices: hedges.replace(/'/g, '"').replace(/(True)|(False)/g, "0"),
      user_id: _this.$store.state.user.all.items.pk_idusers
    }
  };
  apiService
    .getAll(params)
    .then(() => {
      _this.showSavedMsg = true;
      setTimeout(() => (_this.showSavedMsg = false), 2000);
    })
    .catch(function(error) {
      "An error has occurred" + error;
    });
}

export function saveCacheCleaningFlag(_this) {
  _this.refresh = formatDate_MDYHMS(new Date());
  _this.$store.state.user.all.items.clean_cache = _this.refresh;
  let params = {
    method: "POST",
    endpoint: "update_cache_refresh",
    content_type: "application/json",
    query_params: {
      format: "json",
      timestamp: _this.refresh,
      user_id: _this.user.pk_idusers
    }
  };
  apiService
    .getAll(params)
    .then(data => {
      _this.showSavedMsg = true;
      setTimeout(() => (_this.showSavedMsg = false), 2000);
      console.log(typeof data);
    })
    .catch(function(error) {
      "An error has occurred" + error;
    });
}

export function createDataModelTable(_this) {
  _this.modal_processing_message.showModalLoading = true;
  _this.modal_processing_message.messageModal = "Processing download";
  var formatTime = timeFormat("%Y-%m-%d");
  let params = {
    method: "POST",
    endpoint: "create_currency_exposures_file",
    content_type: "application/json",
    query_params: {
      format: "json",
      table: _this.$refs.dt.processedData,
      origin: _this.selection,
      filename:
        _this.companies[_this.selectedCompany].company_name.replace(/ /g, "_") +
        "_" +
        formatTime(new Date())
    }
  };
  apiService
    .getAll(params)
    .then(() => {
      downloadDataModelTable(_this);
    })
    .catch(function(error) {
      "An error has occurred" + error;
    });
}
